import { useTranslation } from "react-i18next";
import { BaseAutocomplete } from "components/inputs/autocomplete/base-autocomplete";

export const BrandedContentSelector = ({
    brandedContentSelection,
    setBrandedContentSelection,
    onBrandedContentSearch,
    availableBrandedContentOptions
}) => {
    const { t } = useTranslation();

    return (
        <div>
            <BaseAutocomplete
                items={availableBrandedContentOptions}
                itemIdKey={"id"}
                itemLabelKey={"name"}
                labels={{
                    appliedItemsLabel: t("platforms:branded-content"),
                    noItemsAppliedLabel: t(
                        "facebook-destination:no-pages-selected"
                    ),
                    inputLabel: t("facebook-destination:search-pages")
                }}
                assignedItems={[brandedContentSelection]}
                variant="search"
                handleAssignItem={(s) => setBrandedContentSelection(s)}
                handleAddItem={(query: string) => {
                    onBrandedContentSearch(query);
                }}
                handleRemoveItem={() => setBrandedContentSelection(null)}
            />
        </div>
    );
};
